import './i18n';
import { StrictMode, Suspense } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { CURRENT_SITE } from './site-config'

// Runtime fallback for document title (covers dev HMR edge cases)
document.title = CURRENT_SITE.displayName;

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Suspense fallback={<div>Loading...</div>}>
      <App />
    </Suspense>
  </StrictMode>,
)
